"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MeshGradient = require('./core/stripe.gradient').Gradient;
exports.default = MeshGradient;
